function pad2(value) {
    return String(value).padStart(2, "0");
}

export function toDateInputMinValue(date = new Date()) {
    const d = date instanceof Date ? date : new Date(date);
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function toDateTimeLocalMinValue(date = new Date()) {
    const d = date instanceof Date ? date : new Date(date);
    return `${toDateInputMinValue(d)}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function isPastDateTimeLocal(value) {
    if (!value) return false;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return true;
    return d.getTime() < Date.now();
}
